import { createRemoteConfigAtomFactory } from '@exodus/remote-config-atoms';
export const defaultValue = {
    default: {
        direct: {
            enabled: true,
        },
        indirect: {
            enabled: true,
            transactionPrivacyNetworks: [],
        },
        chained: {
            enabled: true,
        },
    },
};
const createExchangeRemoteConfigAtom = ({ remoteConfig }) => createRemoteConfigAtomFactory({ remoteConfig })({
    defaultValue,
    path: 'infrastructure.exchange.v3_2',
});
export default createExchangeRemoteConfigAtom;
